import BaseModel from '../base/BaseModel.model';
export default class ProposalScheduleGanttActivity extends BaseModel {

    public taskName: string = null;
    public percentDone: number = 0;
    public percentDoneUI: number = 0;
    public taskId: string = null;
    public phaseId: string = null;
    public resource: string = null;
    public dependencies: string = null;
    public dependenciesUI: Array<string> = [];
    public proposalScheduleGanttPhaseId: number = 0;
    public startDate: Date | null = null;
    public endDate: Date | null = null;

    public phaseStartDateUI: Date | null = null;
    public phaseEndDateUI: Date | null = null;


    init() {
        this.percentDone = 0;
        this.taskName = null;
        this.taskId = null;
        this.resource = null;
        this.dependencies = null;
        this.PorposalId = 0;
        this.startDate = null;
        this.endDate = null;
        this.dependenciesUI = [];
        this.proposalScheduleGanttPhaseId = 0;
        this.phaseId = null;
    }
}